import React from 'react';
import { Router, Switch } from 'react-router-dom';
import * as Route from './components';
import * as Page from '../page';
import history from '../helper/history';
import { ScrollToTop } from '../components';

const AppRouting = () => (
  <Router history={history}>
    <ScrollToTop>
      <Switch>
        <Route.MainPublicRoute path={`/`} component={Page.Home} exact />
        <Route.PublicRoute path={`/advanced-search`} component={Page.AdvancedSearch} logo={false} exact />
        <Route.PublicRoute path={`/advanced-search/:id`} component={Page.AdvancedSearch} logo={false} exact />
        <Route.PublicRoute path={`/advisor-profile/:id`} component={Page.AdvisorProfile} exact />
        <Route.PublicRoute path={`/add-property`} component={Page.AddProperty} exact />
        <Route.PublicRoute path={`/about-us`} component={Page.SimplePage} exact />
        <Route.PublicRoute path={`/contact-us`} component={Page.SimplePage} exact />
        <Route.PublicRoute path={`/why`} component={Page.SimplePage} exact />
        <Route.PublicRoute path={`/announcement/:id`} component={Page.SimplePage} exact />
        <Route.PublicRoute path={`/privacy`} component={Page.SimplePage} exact />
        <Route.PublicRoute component={Page.NotFound} layout={false} />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default AppRouting;
